import PageNavBarLink from "./PageNavBarLink";

export default PageNavBarLink;
